import axios from 'axios'

const baseURL = process.env.VUE_APP_API_URL || 'https://avtotesting.uz/api'

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem('accessToken') ||
      localStorage.getItem('access') ||
      localStorage.getItem('token') ||
      localStorage.getItem('access_token')

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor — 401 da logout
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('user')
      localStorage.removeItem('premium')
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

// Base URL ni export qilib qo'yamiz — rasmlar uchun
export const API_BASE_URL = baseURL
export const MEDIA_BASE_URL = baseURL.replace('/api', '')

export default api